import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';
import { StepStatus } from '@/models/subsidy/status';
import { useRefundRequest } from '@/packages/subsidy/pages/refund-request/context';
import { formatMoney } from '@/utils/format-money';

interface RefundAmountExceededDialogProps {
  onClose: () => void;
  purchaseAmount: number;
}

export const RefundAmountExceededDialog = ({
  onClose,
  purchaseAmount,
}: RefundAmountExceededDialogProps) => {
  const navigate = useNavigate();
  const { resourceApproval, getStepState } = useRefundRequest();
  const { status } = getStepState(2);

  const isApproved = status === StepStatus.Success;
  const salePrice = resourceApproval?.sale_price ?? 0;

  const dialogContent = {
    approved: {
      title: `O valor do comprovante (${formatMoney(purchaseAmount)}) é maior que o valor aprovado (${formatMoney(salePrice)})`,
      description:
        'Para solicitar o reembolso deste valor, você precisa de uma nova aprovação da sua empresa.',
    },
    pending: {
      title: `O valor do comprovante (${formatMoney(purchaseAmount)}) é maior que o valor solicitado (${formatMoney(salePrice)})`,
      description:
        'Para seguir com o reembolso, você precisa pedir de aprovação um valor igual ou superior ao do seu comprovante.',
    },
  }[isApproved ? 'approved' : 'pending'];

  return (
    <BaseDialog
      open
      fullWidth
      onClose={onClose}
      actionsComponent={
        <>
          <Button onClick={onClose} variant="text">
            Voltar
          </Button>
          <Button
            onClick={() => navigate('/meus-reembolsos/novo')}
            variant="contained"
          >
            Solicitar nova aprovação
          </Button>
        </>
      }
      icon={<Icon name="siren-rounded" />}
      title={dialogContent.title}
    >
      <Typography>{dialogContent.description}</Typography>
    </BaseDialog>
  );
};
